import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thirtintwobusonrentinshirdi() {



  const cardData =
  {
    keyword: '32 Seater Bus on Rent in Shirdi',
    heading: 'Sanavi Travels: 32 Seater Bus on Rent in Shirdi',
    headingDescription: 'Sanavi Travels offers reliable 32 Seater Bus on Rent in Shirdi, providing safe, comfortable, and spacious transportation for pilgrims, families, and groups visiting the holy town of Shirdi. Our fleet of well-maintained AC and non-AC 32-seater buses ensures ample seating, smooth rides, and a hassle-free travel experience. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Shirdi and nearby cities including Pune, Mumbai, Nashik, and Aurangabad, covering major attractions such as Sai Baba Temple, Dwarkamai, Chavadi, Lendi Baug, and Shani Shingnapur. Choose Sanavi Travels for trusted 32 seater bus rental services in Shirdi, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is the primary spiritual attraction in Shirdi, dedicated to the revered saint Sai Baba. Millions of devotees visit every year seeking blessings, inner peace, and spiritual guidance. The temple is well-organized, facilitating smooth darshan and participation in sacred aartis."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Samadhi Mandir houses the tomb of Sai Baba and is the heart of the Shirdi temple complex. Devotees experience profound devotion and calm while offering prayers, making it the central spiritual spot in Shirdi."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived and performed miracles for decades. The continuously burning dhuni (sacred fire) symbolizes protection, faith, and devotion, attracting pilgrims throughout the year."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the historic location where Sai Baba used to rest on alternate nights. On Thursdays and during festivals, ceremonial processions are held, maintaining the traditional practices associated with Sai Baba’s life."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba spent time in meditation and tending to plants. The continuously burning Nanda Deep lamp adds to the peaceful and spiritual atmosphere."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is historically important as the place where Sai Baba was first welcomed to Shirdi. It marks the beginning of Sai Baba’s spiritual journey in the town."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a devotional theme park that recreates key events from Sai Baba’s life using statues and traditional settings. It provides an educational and spiritual experience for visitors."
  },
  {
    "title": "Abdul Baba’s Cottage",
    "description": "Abdul Baba’s Cottage commemorates one of Sai Baba’s closest disciples. Visitors come here to reflect on the deep spiritual bond between Sai Baba and his followers."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Shani Shingnapur, located nearby, is famous for its Lord Shani temple and the open-door village tradition. Many pilgrims visit Shani Shingnapur along with Shirdi for a complete spiritual experience."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers recreational fun with water rides, wave pools, and family entertainment. It provides a refreshing break for families visiting Shirdi alongside spiritual activities."
  }
]
,



"services": [
  {
    "name": "32 Seater Bus on Rent in Shirdi",
    "description": "32 Seater Bus on Rent in Shirdi provides spacious and comfortable transportation for families, groups, and corporate travelers visiting Shirdi. Fully air-conditioned buses with ample legroom, clean interiors, and professional chauffeurs ensure a smooth and safe journey. Ideal for religious tours, sightseeing, and long-distance travel, this service emphasizes punctuality, comfort, and convenience."
  },
  {
    "name": "32 Seater Bus Hire Shirdi",
    "description": "32 Seater Bus Hire Shirdi offers reliable bus rental options for group travel, religious tours, and corporate trips. Experienced drivers manage routes efficiently, providing a stress-free and enjoyable travel experience. This service caters to families, tourists, and organizations looking for organized and dependable transportation."
  },
  {
    "name": "AC 32 Seater Bus Shirdi",
    "description": "AC 32 Seater Bus Shirdi ensures a cool and comfortable journey for passengers traveling to Shirdi. Fully air-conditioned buses with spacious seating, smooth suspension, and professional chauffeurs make long trips relaxing and safe. Perfect for family visits, group tours, and corporate travel."
  },
  {
    "name": "Luxury Bus Shirdi",
    "description": "Luxury Bus Shirdi delivers a premium travel experience with high-end amenities, stylish interiors, and superior comfort. Ideal for VIP groups, corporate clients, and special occasions, these buses ensure a refined and enjoyable journey to Shirdi. Professional chauffeurs provide courteous service and timely arrivals."
  },
  {
    "name": "Wedding Bus Shirdi",
    "description": "Wedding Bus Shirdi provides specialized transportation for weddings, accommodating family and guests comfortably. Spacious seating, air-conditioning, and professional drivers ensure a safe and enjoyable ride. Suitable for wedding parties, ceremonies, and related events in and around Shirdi."
  },
  {
    "name": "Corporate Bus Shirdi",
    "description": "Corporate Bus Shirdi caters to businesses and organizations arranging group travel for employees or clients. Reliable, air-conditioned buses with trained chauffeurs offer smooth and timely transportation for corporate tours, meetings, and events in Shirdi."
  },
  {
    "name": "Outstation Bus Shirdi",
    "description": "Outstation Bus Shirdi provides safe and comfortable long-distance travel from nearby cities and towns to Shirdi. Fully air-conditioned buses, professional drivers, and flexible scheduling make it ideal for families, groups, and corporate travelers."
  },
  {
    "name": "Affordable Bus Shirdi",
    "description": "Affordable Bus Shirdi delivers cost-effective group transportation without compromising comfort or safety. Suitable for budget-conscious travelers, families, and tour groups, this service ensures a dependable and smooth journey to Shirdi at economical pricing."
  },
  {
    "name": "Chauffeur Driven Bus Shirdi",
    "description": "Chauffeur Driven Bus Shirdi offers a stress-free travel experience with professional drivers handling traffic, navigation, and route planning. Perfect for family tours, corporate groups, and religious trips, this service prioritizes passenger comfort, safety, and punctuality."
  },
  {
    "name": "Best Bus Service Shirdi",
    "description": "Best Bus Service Shirdi ensures top-quality transportation with well-maintained vehicles, professional chauffeurs, and reliable scheduling. Ideal for group travel, religious tours, and corporate trips, this service provides a comfortable and convenient travel solution to Shirdi."
  },
  {
    "name": "Tourist Bus Shirdi",
    "description": "Tourist Bus Shirdi is designed for sightseeing and leisure travel, offering a comfortable and organized journey for visitors exploring Shirdi and nearby attractions. Spacious, air-conditioned buses with knowledgeable drivers provide a safe and enjoyable experience."
  },
  {
    "name": "Group Travel Bus Shirdi",
    "description": "Group Travel Bus Shirdi specializes in transporting large groups for religious tours, events, and corporate trips. Air-conditioned buses with ample seating, luggage space, and trained chauffeurs ensure a smooth, safe, and convenient travel experience."
  },
  {
    "name": "Online Bus Booking Shirdi",
    "description": "Online Bus Booking Shirdi allows passengers to reserve 32 seater buses quickly and easily through a web or mobile platform. Users can select dates, pickup points, and trip preferences, ensuring a hassle-free, reliable, and convenient travel experience to Shirdi."
  },
  {
    "name": "Sai Darshan Bus",
    "description": "Sai Darshan Bus provides dedicated transportation for pilgrims visiting Shirdi’s Sai Baba Temple. Comfortable seating, air-conditioned interiors, and professional drivers ensure a safe and serene journey for devotees attending religious tours and temple visits."
  },
  {
    "name": "Shirdi Travel Bus",
    "description": "Shirdi Travel Bus offers comprehensive travel solutions for tourists, families, and corporate groups visiting Shirdi. With air-conditioned buses, experienced chauffeurs, and flexible itineraries, this service emphasizes comfort, reliability, and timely travel for all passengers."
  }
],
"tableData": [
  ["32 Seater Bus on Rent in Shirdi", "32 Seater Bus Hire Shirdi"],
  ["AC 32 Seater Bus Shirdi", "Luxury Bus Shirdi"],
  ["Wedding Bus Shirdi", "Corporate Bus Shirdi"],
  ["Outstation Bus Shirdi", "Affordable Bus Shirdi"],
  ["Chauffeur Driven Bus Shirdi", "Best Bus Service Shirdi"],
  ["Tourist Bus Shirdi", "Group Travel Bus Shirdi"],
  ["Online Bus Booking Shirdi", "Sai Darshan Bus"],
  ["Shirdi Travel Bus", "—"]
]
,

"whychoose": [
  {
    "WhyChooseheading": "32 Seater Bus on Rent in Shirdi with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers 32‑seater buses on rent in Shirdi, perfect for group trips, religious pilgrimages, family outings, corporate events, and local tours."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced 32‑seater buses that ensure a comfortable and enjoyable journey in and around Shirdi."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with local routes and nearby travel spots, ensuring safe and timely transportation for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for 32‑seater bus rentals in Shirdi, inclusive of fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any last‑minute changes for your 32‑seater bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your travel schedule and group requirements in Shirdi."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 32‑seater buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 32‑seater bus rentals in Shirdi."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 32‑seater buses on rent in Shirdi?',
    answer: 'Yes, Sanavi Travels offers 32‑seater buses for group trips, corporate events, pilgrimages, and local tours in Shirdi.'
  },
  {
    question: 'How can I book a 32‑seater bus in Shirdi?',
    answer: 'You can easily book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the 32‑seater buses well‑maintained and air‑conditioned?',
    answer: 'Yes, all our 32‑seater buses are clean, air‑conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with local and outstation routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with both local Shirdi routes and nearby destinations.'
  },
  {
    question: 'Can I rent the 32‑seater bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half‑day, full‑day, and customized rental packages to meet your travel needs.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all 32‑seater buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support team is available throughout your 32‑seater bus rental.'
  },
  {
    question: 'What payment options are available for 32‑seater bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for 32‑seater bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on‑time pickups and reliable service for all 32‑seater bus bookings in Shirdi.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Sharma',
    feedback: 'Booked a 32‑seater bus in Shirdi for our family trip. Spacious, comfortable, and the driver was very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Nisha Rao',
    feedback: 'Excellent 32‑seater bus rental service in Shirdi. Smooth ride, punctual service, and helpful staff.',
    rating: 5
  }
];




















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32 Seater Bus on Rent in Shirdi - Sanavi Travels",
  "description": "Sanavi Travels offers 32 seater bus rental services in Shirdi for weddings, corporate trips, outstation travel, and Sai Darshan tours. AC, luxury, and chauffeur-driven buses available with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "210"
  }
};








  return (
    <div>
<Helmet>
  <title>
    32 Seater Bus on Rent in Shirdi | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 32 seater bus in Shirdi with Sanavi Travels for weddings, corporate trips, outstation travel, and Sai Darshan. AC, luxury, and chauffeur-driven buses available with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Thirtintwobusonrentinshirdi;